var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    'f-input-wrapper': true,
    'is-with-dropdown': _vm.withDropdown,
    'is-multiple-fields': _vm.multipleFields,
    'is-append': _vm.append,
    'is-prepend-icon': _vm.prependIcon && _vm.prependIcon.length
    }},[(_vm.prependIcon && _vm.prependIcon.length)?[_c('f-icon',{attrs:{"name":_vm.prependIcon}})]:_vm._e(),_vm._t("default"),(_vm.append)?_c('div',{staticClass:"f-input-wrapper-appendix"},[_vm._v(" "+_vm._s(_vm.append)+" ")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }